




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ImagePreviewEditable from './ImagePreviewEditable.vue'
import ImageUploadForm from './ImageUploadForm.vue'

@Component({
  components: {
    'image-preview-editable': ImagePreviewEditable,
    'image-upload-form': ImageUploadForm,
  },
})
export default class InputFormImage extends Vue {

  @Prop({ required: true })
  uploadHandler: (file: File|null, index: number) => void

  @Prop({ required: true })
  deleteHandler: (index: number) => void

  @Prop({ required: true })
  max: number

  @Prop({ required: true })
  previews: File[]

  get nextIndex(): number {
    return this.previews.length
  }

  get showUploadForm(): boolean {
    return this.previews.length < this.max
  }
}
